import { useState, useContext, useEffect } from 'react';
import { NavLink, useSearchParams } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from '../context/AuthContext';
import { ProjectsContext } from '../context/ProjectsContext';

import projectsSearch  from "../utils/Search";

export default function Search() {

	const { currentUser, user } = useContext(AuthContext);
	const { projects } = useContext(ProjectsContext);

	const [foundProjects, setFoundProjects] = useState(false);

	const [searchParams, setSearchParams] = useSearchParams();
	const defaultString = searchParams.get('q');

	const {
		getValues,
		register
    } = useForm({
    });

	const navigate = useNavigate();

	//==================================================================
	// show quick search suggestions

	const quickSearch = async event => {

		if (event.key !== "Enter" && projects) {
			let searchString = event.target.value;
			let result = projectsSearch(searchString, projects);
			setFoundProjects(result);
		}
	}

	//==================================================================
	// click outside the search box => hide suggestions

	useEffect(() => {
		const page = document.querySelector('.page');
		page.addEventListener("click", function(event){
			var container =  document.querySelector('.search');
			if (!(container.contains(event.target) && event.target !== container))
				setFoundProjects(false);
		});
	});


	const SearchPage = async (e) => {
		e.preventDefault();
		let data = getValues();
		if (data['q']){
			setFoundProjects(false);
			navigate("/search?q="+data['q'], true);
			console.log('foundProjects')
			console.log(foundProjects)
		}
	}

    return (

		<div className="search">
			<form onSubmit={SearchPage}>
				<input
					type="text"
					{...register("q")}
					placeholder={"Search"}
					defaultValue={defaultString}
					onKeyUp={quickSearch}
				/>
				<input type="submit" className="search-submit" value="" />
			</form>

			{foundProjects &&
				<>
					{(foundProjects.length == 0) ?
						<>

						</>
						:
						<div className="quick-search">
							{foundProjects.map((project, index) =>
								<NavLink to={"/edit/"+project.id} className={
									'project' +
									(project['userFoundInSearch'] ? ' project-with-user' : '')
								} key={index}>
									{project.name}

									{project['userFoundInSearch'] &&

										<span className="user"> &nbsp;&nbsp;&nbsp;
											(User: {project['userFoundInSearch'].firstName + ' ' + project['userFoundInSearch'].lastName})
										</span>

									}
								</NavLink>
							)}
						</div>
					}
				</>
			}

		</div>
    )
}


